/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJobPositionCommand
 */
export interface UpdateJobPositionCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobPositionCommand
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobPositionCommand
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateJobPositionCommand interface.
 */
export function instanceOfUpdateJobPositionCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateJobPositionCommandFromJSON(json: any): UpdateJobPositionCommand {
    return UpdateJobPositionCommandFromJSONTyped(json, false);
}

export function UpdateJobPositionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobPositionCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function UpdateJobPositionCommandToJSON(value?: UpdateJobPositionCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

